export default __webpack_public_path__ + "c4a68d90b03ac61bbe3e40d2a0eea6b7.png";